import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Opens a Bootstrap modal on connect, and (optionally) opens a follow-up
// modal once the first is dismissed.
//
// Usage:
//   <div data-controller="modal-chain"
//        data-modal-chain-first-value="modal_id_a"
//        data-modal-chain-then-value="modal_id_b"></div>
export default class extends Controller {
  static values = {
    first: String,
    then:  String,
  }

  connect() {
    const firstEl = document.getElementById(this.firstValue)
    if (!firstEl) return

    // Tiny delay so sibling controllers (e.g. onboarding auto-show) finish
    // their own connect() before we take over.
    setTimeout(() => {
      Modal.getOrCreateInstance(firstEl).show()

      if (this.hasThenValue) {
        const thenEl = document.getElementById(this.thenValue)
        if (thenEl) {
          firstEl.addEventListener("hidden.bs.modal", () => {
            Modal.getOrCreateInstance(thenEl).show()
          }, { once: true })
        }
      }
    }, 50)
  }
}
